import {useMutation} from '@tanstack/react-query'
import {SFRAApiProvider} from '../../SFRAApiProvider'

interface applePayValidateMerchantBody {
    body: {
        isTrusted: boolean
        validationURL: string
        hostname: string
    }
}

const applePayController = async ({provider, body}) => {
    try {
        const {setUrl, setHeaders, handleResponse} = provider

        const request = {
            method: 'POST',
            headers: {
                ...(await setHeaders()),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        }

        const response = await fetch(
            setUrl({
                endpoint: '/__SYSTEM__ApplePay-ValidateMerchant',
            }),
            request,
        )

        return await handleResponse(response)
    } catch (error) {
        console.error(error)
        return {}
    }
}

export const useSFRAApplePayController = (hostLink: string) => {
    const provider = SFRAApiProvider({hostLink})

    return useMutation(async (params: applePayValidateMerchantBody) => {
        return await applePayController({provider, ...params})
    })
}
